import React from 'react';
import { BrowserView } from 'react-device-detect';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Icone from 'Component/Icone';
import Curriculo from 'Interface/Curriculos';
import { useRemoverCurriculoMutation } from 'View/Service/Default/Curriculos';

interface Props {
  dados: Curriculo;
}

const Lista = ({ dados }: Props): React.ReactElement => {
  const toast = useToast();
  const [removerCurriculo] = useRemoverCurriculoMutation();

  const remover = async (): Promise<void> => {
    try {
      await removerCurriculo(dados).unwrap();

      toast({
        conteudo: 'Removido com sucesso!',
        tema: 'success',
      });
    } catch (erro) {
      toast({
        titulo: 'Erro ao remover',
        conteudo: 'Verifique o registro de log para mais detalhes!',
        tema: 'danger',
      });
    }
  };

  return (
    <div
      key={dados.nome}
      className={`d-flex border-bottom align-items-center py-2 px-3 ${dados.categoria_id == 1 ? 'bg-danger bg-opacity-25' : ''}`}
    >
      <div className="fs-4">
        <Link
          to={`/curriculos/editar/${dados.id}`}
          className="text-decoration-none"
        >
          {dados.nome}{' '}
          <small>
            ({dados.vaga})
          </small>
          <small className="d-block fs-6 text-muted">{dados.email}</small>
        </Link>
      </div>
      <BrowserView className="d-flex flex-grow-1 align-items-center justify-content-end">
        <div className="ms-5 fs-5 text-end">
          {dados.departamento?.nome}
          <small className="d-block fs-6 text-muted">Departamento</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          {dados.categoria?.nome}
          <small className="d-block fs-6 text-muted">Categoria</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          {dados.criado.data().toLocaleString()}
          <small className="d-block fs-6 text-muted">Criado em</small>
        </div>
        <div className="ms-5 fs-5 text-end">
          <a
            href={dados.url}
            className="btn btn-success"
            target="_blank"
            rel="noreferrer"
          >
            <Icone nome="cloud-download" />
          </a>
          <Botao
            icone="trash"
            tema="danger"
            className="ms-2"
            confirmacao="Você tem certeza que deseja remover esse currículo? Essa ação é irreversivel."
            onClick={remover}
          />
        </div>
      </BrowserView>
    </div>
  );
};

export default Lista;
